// @flow
import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  PageContainer,
  Title,
  DescriptionContainer,
  Description,
} from './Styles';

const NotFound = () => {
  const { t } = useTranslation();

  return (
    <PageContainer>
      <Title>{t('notfound_error_title')}</Title>
      <DescriptionContainer>
        <Description>{t('notfound_error_description')}</Description>
        <Description>{t('notfound_error_description2')}</Description>
        <Description>{t('notfound_error_description3')}</Description>
        <Description>{t('notfound_error_description4')}</Description>
      </DescriptionContainer>
    </PageContainer>
  );
};

export default NotFound;
